export const changeSpaceToUnderline = (str: string) => str.replace(/\s/g, '_');
